import { createResource, type RouteResourceResponse } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags';

import { getContacts } from '../endpoints';

// Redefined here since it is not exported from RRR.
type ResourceDependencies = {
	[type: string]: RouteResourceResponse;
};

export const createContactsResource = (
	checkConsolidationOnRouteDependency?: (dependencies: ResourceDependencies) => boolean,
	depends?: string[],
) =>
	createResource({
		type: 'contactsResource',
		getKey: () => 'contactsResource',
		getData: async ({ dependencies, match }) => {
			const targetAccountId = fg('jsm_admin_access_user_notification_settings')
				? match.params?.targetAccountId
				: undefined;
			const isConsolidated = checkConsolidationOnRouteDependency
				? // @ts-ignore - Type 'undefined' is not assignable to type 'RouteResourceResponse'.
					// This was added when enrolling @atlassian/eoc-notifications into JFE local consumption.
					checkConsolidationOnRouteDependency(dependencies)
				: true;

			if (!isConsolidated) {
				return null;
			}
			const data = await getContacts(targetAccountId);
			return data.contacts;
		},
		isBrowserOnly: true,
		depends,
	});

// Only meant to be used in platform
export const contactsResource = createContactsResource();
